import { ProductionTechnology } from './shared/models/production-technology.enum'
import { MarketingType } from './shared/models/marketing-type.enum'

export const CONTACT_EMAIL = 'sales-vermarktung@enbw.com'

export const PRODUCTION_TECHNOLOGY_OPTIONS = [
  { value: ProductionTechnology.Solar, label: 'Solar' },
  { value: ProductionTechnology.WindOnshore, label: 'Wind-Onshore' },
]

export const MARKETING_TYPE_OPTIONS = [
  {
    value: MarketingType.EEGDirectMarketing,
    label: 'EEG-Direktvermarktung nach Marktprämienmodell (gefördert)',
  },
  {
    value: MarketingType.Other,
    label: 'Sonstige Direktvermarktung (ungefördert sowie Post-EEG)',
  },
]
